import { createContext, ReactNode, useContext, useState } from 'react'
import { StudentRelationship } from '@/app/pages/family_application/hooks/useUpdateFamilyApplication.ts'

interface FormData {
  first_name: string
  last_name: string
  relation_to_student: StudentRelationship
  grade_level: string
  social_security_number: string
  cssp: boolean
  snosp: boolean
  acedmic_cource_joined: string
  birth_date?: Date
  DateOfBirhImage?: string
  DateOfBirhImageUrl?: string
  DateOfBirthFile?: File
}

type WizardContext = {
  formData: FormData
  updateFormData: (field: keyof FormData, value: any) => void
  resetFormData: () => void
}

const Context = createContext<WizardContext | undefined>(undefined)

export const StudentDetailsWizardProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const initialFormData: FormData = {
    first_name: '',
    last_name: '',
    relation_to_student: 'parent',
    grade_level: '',
    social_security_number: '',
    cssp: false,
    snosp: false,
    acedmic_cource_joined: 'No',
    DateOfBirhImage: '',
    DateOfBirhImageUrl: '',
  }

  const [formData, setFormData] = useState<FormData>(initialFormData)

  const updateFormData = (field: keyof FormData, value: any) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }))
  }

  const resetFormData = () => {
    setFormData(initialFormData)
  }

  return (
    <Context.Provider
      value={{
        formData,
        updateFormData,
        resetFormData,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useWizardContext = () => {
  const context = useContext(Context)

  if (context === undefined)
    throw new Error('useWizardContext must be used within the WizardProvider')
  return context
}
